module.exports = __webpack_public_path__ + "img/youtube.d99846f6.png";